import { render, staticRenderFns } from "./addwelfare.vue?vue&type=template&id=1b10a4ed&scoped=true"
import script from "./addwelfare.vue?vue&type=script&lang=js"
export * from "./addwelfare.vue?vue&type=script&lang=js"
import style0 from "./addwelfare.vue?vue&type=style&index=0&id=1b10a4ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b10a4ed",
  null
  
)

export default component.exports